// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__B0wnW","loader":"loader__21omv","img":"img__ETZzM"};